export default {
    orderCardError: {
        dataTrackId: 'order-card-error',
        dataTrackLinkname: 'bestill kort feil',
    },
    orderCardReceiptOk: {
        dataTrackId: 'order-card-receipt-ok',
        dataTrackLinkname: 'bestill kort - suksess ok',
    },
    orderCardNext: {
        dataTrackId: 'order-card-next',
        dataTrackLinkname: 'neste',
    },
    orderCardCancel: {
        dataTrackId: 'order-card-cancel',
        dataTrackLinkname: 'bestill kort avbryt',
    },
    orderCardConfirm: {
        dataTrackId: 'order-card-confirm',
        dataTrackLinkname: 'bestill kort bekreft',
    },
    orderCardSuccess: {
        dataTrackId: 'order-card-receipt',
        dataTrackLinkname: 'bestill kort suksess',
    },
    orderCardPriceListLink: {
        dataTrackId: 'order-card-price-list-link',
        dataTrackLinkname: 'bestill kort lenke prisliste',
    },
};
